<template>
    <el-dialog
        class="selectPlatform"
        :visible.sync="selectPlatformVisible"
        :close-on-click-modal="false"
        @closed="closeDialog"
        width="740px"
        title="Batch Publish"
        :lock-scroll="false"
        :modal-append-to-body="false"
        append-to-body
    >
        <div class="container" v-show="isPublish == 'not'" v-loading="loading">
            <div class="store-items" v-show="btnText == 'NEXT'">
                <div
                    class="store-item"
                    :class="{ active: item.id == storeId }"
                    v-for="item of platformList"
                    :key="item.id"
                    @click="chiocePlatform(item)"
                >
                    <img
                        :style="{
                            width: item.code == 'shoplazza' ? '25%' : '',
                        }"
                        :src="
                            require('@/assets/image/goods/' +
                                item.code +
                                '.png')
                        "
                    />
                </div>
            </div>
            <el-form
                ref="publishForm"
                :model="publishForm"
                label-width="100px"
                v-show="btnText != 'NEXT'"
            >
                <el-row :gutter="20">
                    <el-col :span="24">
                        <el-form-item size="small">
                            <img class="store-img" :src="storeImgSrc" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item
                            :label="$t('goodsList.selectPlatform.store')"
                            :rules="[
                                {
                                    required: true,
                                    message: `${$t(
                                        'goodsList.selectPlatform.selectPlaceholder'
                                    )}${$t('goodsList.selectPlatform.store')}`,
                                },
                            ]"
                            prop="shop_id"
                            size="small"
                        >
                            <el-select
                                v-model="publishForm.shop_id"
                                size="small"
                                :placeholder="`${$t(
                                    'goodsList.selectPlatform.selectPlaceholder'
                                )}${$t('goodsList.selectPlatform.store')}`"
                                filterable
                            >
                                <el-option
                                    v-for="item in storeList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <!-- <el-col :span="24" v-if="this.storeId != 4">
                        <el-form-item
                            :label="$t('goodsList.selectPlatform.template')"
                            size="small"
                        >
                            <el-select
                                v-model="publishForm.template"
                                size="small"
                                :placeholder="`${$t(
                                    'goodsList.selectPlatform.selectPlaceholder'
                                )}${$t('goodsList.selectPlatform.template')}`"
                                filterable
                            >
                                <el-option
                                    v-for="item in templateList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" v-if="this.storeId != 4">
                        <el-form-item
                            :label="$t('goodsList.selectPlatform.vendor')"
                            prop="vendor"
                            size="small"
                        >
                            <el-input
                                clearable
                                :placeholder="`${$t(
                                    'goodsList.selectPlatform.inputPlaceholder'
                                )}${$t('goodsList.selectPlatform.vendor')}`"
                                size="small"
                                v-model="publishForm.vendor"
                            >
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" v-if="this.storeId != 4">
                        <el-form-item
                            :label="$t('goodsList.selectPlatform.scope')"
                            prop="published_scope"
                            size="small"
                        >
                            <el-select
                                v-model="publishForm.published_scope"
                                size="small"
                                :placeholder="`${$t(
                                    'goodsList.selectPlatform.selectPlaceholder'
                                )}${$t('goodsList.selectPlatform.scope')}`"
                                filterable
                            >
                                <el-option
                                    v-for="item in scopeList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.value"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col> -->
                    <el-col :span="24" v-if="this.storeId != 4">
                        <el-form-item
                            :label="$t('goodsList.selectPlatform.status')"
                            prop="listing_status"
                            size="small"
                        >
                            <el-radio-group
                                v-model="publishForm.listing_status"
                            >
                                <el-radio
                                    :label="`${$t(
                                        'goodsList.selectPlatform.statusRadios.draft'
                                    )}`"
                                    >{{
                                        $t(
                                            "goodsList.selectPlatform.statusRadios.Draft"
                                        )
                                    }}</el-radio
                                >
                                <el-radio
                                    :label="`${$t(
                                        'goodsList.selectPlatform.statusRadios.active'
                                    )}`"
                                    >{{
                                        $t(
                                            "goodsList.selectPlatform.statusRadios.Active"
                                        )
                                    }}</el-radio
                                >
                                <el-radio
                                    :label="`${$t(
                                        'goodsList.selectPlatform.statusRadios.archived'
                                    )}`"
                                    >{{
                                        $t(
                                            "goodsList.selectPlatform.statusRadios.Archived"
                                        )
                                    }}</el-radio
                                >
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <span slot="footer" v-show="['not', 'processing', 'done'].includes(isPublish)" class="dialog-footer">
            <template v-if="isPublish === 'not'">
            <el-button
                size="small"
                v-show="btnText == 'PUBLISH'"
                @click="btnFn('Prev')"
                >Prev</el-button
            >
            <el-button size="small" type="primary" @click="btnFn(btnText)">{{
                btnText
            }}</el-button>
            </template>
            <el-button v-else size="small" @click="closeDialog()">Close</el-button>
        </span>
        <div class="publishing" v-show="isPublish == 'ing'">
            <!-- <p>Closing this pop-up window does not affect the file</p>
            <p style="margin: 10px 0 50px">
                generation, you will be notified after the file is generated
            </p> -->
            <el-progress
                type="circle"
                :percentage="percentage"
                color="#635cff"
                width="105"
            ></el-progress>
            <p style="margin: 15px 0 0">In progress...</p>
        </div>
        <div class="published-tip" v-show="isPublish == 'processing'">
            <img :src="statusSvg" style="width: 128px; margin-bottom: 50px;" />
            <p>
                Please wait patiently. It is being processed.
            </p>
        </div>
        <div class="published-tip" v-show="isPublish == 'done'">
            <!-- <i class="el-icon-circle-check"></i> -->
            <img :src="statusSvg" style="width: 128px; margin-bottom: 50px;" />
            <div class="alert fail" v-if="publishResult.f_total > 0">
                Processing failed {{publishResult.f_total}} product releases.
                <i class="el-icon-view" @click="detailVisible = true"/>
            </div>
            <div class="alert success" v-if="publishResult.s_total > 0">
                Successfully processed {{publishResult.s_total}} product releases. 
                <!-- <i class="el-icon-view" @click="closeDialog(); $router.push({path: '/listingRecord', query: {keyword:batch_no, status: '1'}})"/> -->
            </div>
        </div>
        <detail
            :detailVisible.sync="detailVisible"
            :tableItem.sync="tableItem"
            status = "2"
        ></detail>
    </el-dialog>
</template>

<script>
import { cmofferApi } from "@/http/cmofferApi.js";
import detail from "@/views/pages/listingAdmin/listingRecord/detail";
export default {
    data() {
        return {
            btnText: "NEXT",
            platformList: [],
            templateList: [],
            storeList: [],
            scopeList: [
                {
                    value: "web",
                    name: "web",
                },
                {
                    value: "global",
                    name: "global",
                },
            ],
            loading: false,
            chooseResult: {},
            platform_id: "",
            storeId: null,
            storeImgSrc: "",
            publishForm: {
                shop_id: "",
                //template: null,
                //vendor: "",
                //published_scope: "",
                listing_status: "draft",
                goodsIdList: [],
            },
            isPublish: "not",
            publishResult: {
                total_product: 0,
                s_total: 0,
                f_total: 0
            },
            percentage: 0,
            percentTimer: null,
            statusSvg: '',
            batch_no: '',
            detailVisible:false,
        };
    },
    methods: {
        // 批量刊登
        batchPublication() {
            // this.percentTimer && clearInterval(this.percentTimer);
            // this.percentTimer = setInterval(() => {
            //     if (this.percentage < 99) {
            //         this.percentage++;
            //     }
            // }, 300);
            cmofferApi
                .batchPublication(
                    {
                        ...this.publishForm,
                    },
                    "post"
                )
                .then((res) => {
                    if (res) {
                        // this.percentage = 99;
                        // this.percentTimer && clearInterval(this.percentTimer);
                        this.isPublish = "processing";
                        this.statusSvg = require('@/assets/image/processing.png')
                        this.batch_no = res.batch_no;
                        this.percentTimer = setInterval(() => {this.listingRecord(res.batch_no)}, 1000)
                        // 清空已选的批量刊登的商品
                        this.$store.commit("GOODSSELECTED_LIST", []);
                        this.$parent.getGoodsList();
                        this.$ga.event(
                            "engagement",
                            "prod_publish",
                        );
                    }
                });
        },
        listingRecord(batch_no) {
            cmofferApi
                .listingRecord(
                    {batch_no},
                    "get"
                )
                .then((res) => {
                    if (res && res.data) {
                        const { total_product, s_total, f_total } = res.data[0];
                        if (total_product === s_total + f_total) {
                            clearInterval(this.percentTimer)
                            this.isPublish = 'done';
                            this.statusSvg = require('@/assets/image/done.png')
                            this.publishResult = {total_product, s_total, f_total};
                            this.tableItem =  res.data[0];
                            return
                        }
                    }
                });
        },
        btnFn(btnText) {
            if (btnText == "NEXT") {
                if (this.storeId) {
                    this.$refs["publishForm"].clearValidate();
                    this.btnText = "PUBLISH";
                    this.shopSelect(this.storeId);
                    this.platformList.map((item) => {
                        if (this.storeId == item.id) {
                            this.storeImgSrc = require(`@/assets/image/goods/${item.code}.png`);
                        }
                    });
                } else {
                    this.$message.warning("请选择平台");
                }
            } else if (btnText == "PUBLISH") {
                this.$refs["publishForm"].validate((valid) => {
                    if (valid) {
                        this.isPublish = "ing";
                        this.batchPublication();
                    }
                });
            } else if (btnText == "Prev") {
                this.btnText = "NEXT";
            }
        },
        closeDialog() {
            clearInterval(this.percentTimer)
            this.percentage = 0;
            this.publishForm = {};
            this.btnText = "NEXT";
            this.isPublish = "not";
            this.storeId = null;
            this.$refs["publishForm"].clearValidate();
            this.$emit("update:selectPlatformVisible", false);
        },
        /**
         * 店铺下拉列表获取
         */
        shopSelect(id) {
            var data = id ? {platform_id:id} : {};
            cmofferApi.shopSelect(data, "get").then((res) => {
                if (res) {
                    this.storeList = res.data;
                }
            });
        },
        /**
         * 平台下拉列表获取
         */
        platformSelect() {
            this.loading = true;
            cmofferApi.platformSelect({platform_id:this.storeId,type:"listing"}, "get").then((res) => {
                if (res) {
                    this.platformList = res.data;
                    this.loading = false;
                }
            });
        },
        chiocePlatform(item) {
            this.storeId = item.id;
            this.btnFn("NEXT");
        },
        async initialize() {
            await this.platformSelect();
            await this.shopSelect();
        },
    },
    components: {
        detail,
    },
    props: {
        selectPlatformVisible: Boolean,
        tableItem: Object,
        selectList: Array,
    },
    watch: {
        selectPlatformVisible(value) {
            if (value) {
                console.log("selectList", this.selectList);
                this.publishForm.goodsIdList = this.selectList;
                this.initialize();
            }
        },
    },
    created() {},
    destroyed() {
        clearInterval(this.percentTimer)
    },
};
</script>

<style lang="scss" scoped>
.selectPlatform {
    .container {
        .store-items {
            display: flex;
            flex-wrap: wrap;
            padding: 30px;
            .store-item {
                width: 140px;
                height: 60px;
                display: flex;
                align-items: center;
                justify-content: center;
                border: 2px solid #f3f3f3;
                border-radius: 6px;
                box-sizing: border-box;
                margin: 0 30px 30px 0;
                cursor: pointer;
                img {
                    width: 60%;
                }
                &:nth-child(4) {
                    margin-right: 0;
                }
                &:hover {
                    box-shadow: 0 0 5px 0 rgba(200, 200, 200, 0.6);
                }
            }
            .active {
                border-color: $color-primary;
            }
            .shopify {
                img {
                    width: 70%;
                }
            }
            .etsy {
                img {
                    width: 40%;
                }
            }
            .amazon {
                img {
                    width: 50%;
                }
            }
            .ebay {
                img {
                    width: 45%;
                }
            }
        }
        .el-form-item__content {
            .el-select,
            .el-select--small {
                width: 100%;
            }
            .is-disabled {
                .el-input__inner {
                    color: #606266;
                }
            }
            .el-input-group__prepend {
                padding: 0;
                width: 100px;
                color: #666;
                text-align: center;
            }
            .store-img {
                width: 110px;
            }
        }
    }
    .published-tip,
    .publishing {
        padding: 90px 0;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        font-size: 16px;
        i {
            font-size: 90px;
            color: $color-primary;
            margin-bottom: 30px;
        }
    }
    .published-tip {
        padding: 30px 0;
        p {
            width: 80%;
            text-align: center;
        }
        .alert {
            margin-bottom: 20px;
            border-width: 1px;
            border-style: solid;
            font-size: 14px;
            width: 80%;
            box-sizing: border-box;
            padding: 4px 12px;
            line-height: 200%;

            i {
                float: right;
                font-size: 16px;
                margin-bottom: 0;
                line-height: 200%;
                cursor: pointer;
            }

            &.fail {
                border-color: #e15b43;
                color: #e15b43;
                background-color: #fee9e8;

                i {
                    color: #e15b43;
                }
            }

            &.success {
                border-color: #379d82;
                color: #379d82;
                background-color: #d4f5e7;

                i {
                    color: #379d82;
                }
            }
        }
    }
}
</style>